import React, { Component } from "react";
import {
  ActivityIndicator,
  Image,
  Dimensions,
  Text,
  TouchableOpacity,
  View,
  Platform,
  RefreshControl,
} from "react-native";
import AsyncStorage from "@react-native-community/async-storage";
import Timeline from "react-native-timeline-flatlist";
import _ from "lodash";

import Header from "../components/Header";
import ParallaxScrollView from "react-native-parallax-scroll-view";
import AutoHeightImage from "react-native-auto-height-image";
import { NavigationEvents } from "react-navigation";
import staticColors from "../constants/staticColors";
import { API, axios } from "../helpers/axios";

import {
  APP_BASE_URL,
  getConsultation,
  getMedical,
  setConsultation,
  setMedical,
} from "../helpers/storage";
import moment from "moment";
import { connect } from "react-redux";
import TimelineSection from "../components/TimelineSection";
import PatientAvatarWithDetail from "../components/PatientAvatarWithDetail";
import PatientDetailMore from "../components/PatientDetailMore";
import TimelineItem from "../components/TimelineItem";
import fonts from "../constants/fonts";
import { changeAccessToken, resetTokenStore } from "../actions/token";
import { saveClientId } from "../actions/appConfig";

class CustomerProfileScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      firstName: "",
      fullName: "",
      cardNumber: "",
      organization: "",
      status: "",
      class: "",
      age: 0,
      gender: "m",
      birthdate: new Date(),
      phone: "",
      email: "",
      id: "",
      dependenceStatus: "",
      activeConsultation: null,
      medical: null,
      historiesTotal: 0,
      historiesData: [],
      isLoading: true,
      symptomsCheckUrl: "",
      loading: false,
      config: {},
      hasViId: false,
    };
  }

  _onPress = () => {
    if (this.state.medical) {
      if (this.state.activeConsultation) {
        this.props.navigation.navigate("Waiting", {
          clientAppId: this.state.clientAppId,
          patientId: this.state.id,
          newPatientId: this.state.newPatientId,
          activeConsultation: this.state.activeConsultation,
          hasViId: this.state.hasViId,
          enableVoiceCall: this.state.config.is_voice_call_enabled,
          enableVideoCall: this.state.config.is_video_call_enabled,
          inboxId: this.state.inboxId,
          websiteToken: this.state.websiteToken,
          transactionId: this.state.transactionId,
          activeTransaction: this.state.activeTransaction,
        });
      } else {
        this.props.navigation.navigate("ask", {
          clientAppId: this.state.clientAppId,
          patientId: this.state.id,
          newPatientId: this.state.newPatientId,
          firstName: this.state.firstName,
          config: this.state.config,
          dependenceStatus: this.state.dependenceStatus,
          hasViId: this.state.hasViId,
          enableVoiceCall: this.state.config.is_voice_call_enabled,
          enableVideoCall: this.state.config.is_video_call_enabled,
          clientId: this.state.clientId,
          hasDoB: this.state.hasDoB
        });
      }
    } else {
      this.props.navigation.navigate("Medical", {
        patientId: this.state.newPatientId,
        birthdate: this.state.birthdate,
        cardNumber: this.state.cardNumber,
        fullName: this.state.fullName,
        gender: this.state.gender,
        age: this.state.age,
        height: null,
        weight: null,
      });
    }
  };

  onHistoryPress = () => {
    const { cardNumber, fullName, gender, config, newPatientId } = this.state;
    this.props.navigation.navigate("PrescriptionHistory", {
      cardNumber,
      fullName,
      gender,
      config,
      patientId: newPatientId,
    });
  };

  onMedicalCheckPress = () => {
    this.props.navigation.navigate("MedicalCheck", {
      url: `https://dev.diagnosa.prixa.ai/partner/dc6d7de0-cb0b-11ea-aa8b-6521aef536d7/app/a65ff9f0-dac6-11ea-811b-b3b0a791cc9e`,
      patientId: this.state.id,
    });
  };

  checkLaunchStatus() {
    if (this.props.introSlides.length > 0) {
      this.props.navigation.navigate("intro");
    }
  }

  async fetchProfile() {
    try {
      setConsultation(null);

      this.setState({ loading: true });

      // ---------- new flow with external users ----------
      // get external user data
      const { data: profileData } = await API.get(
        `${APP_BASE_URL}/v1/external/users/me`,
        {
          headers: {
            "X-Client-Id": this.props.clientId,
          },
        }
      );

      // get list of family (include patient)
      const {
        data: { data: patientList },
      } = await API.get(`${APP_BASE_URL}/v1/patients/user/${profileData.id}`);

      // find main patient (or main card holder)
      let mainPatient = patientList.find(
        (patient) => patient.dependecy_status === "0"
      );
      // if no main patient in the list, get the first one
      if (!mainPatient) mainPatient = patientList[0];

      const resp = await API.get(
        `${APP_BASE_URL}/v2/profile/${mainPatient.id}/me`
      );

      mainPatient = resp.data.data;

      // get list of consultation histories
      const {
        data: {
          data: consultationsHistories,
          total: consultationsHistoriesTotal,
        },
      } = await API.get(
        `${APP_BASE_URL}/v2/profile/${mainPatient.id}/consultation-history`
      );
      console.log({
        profileData,
        mainPatient,
        patientList,
        consultationsHistories,
      });

      // prepare data for consultation histories
      const histories = [];
      let lastDate;

      _.each(consultationsHistories, (item) => {
        const n = moment(item["created_at"]);

        const date = n.format("D MMMM YYYY");

        if (lastDate !== date) {
          histories.push({
            type: "section",
            date: n.toDate(),
            icon: require("../assets/round_access_time_white_18dp.png"),
          });

          lastDate = date;
        }

        histories.push({
          type: "single",
          doctor: {
            avatar: {
              uri: item["doctor_photo"],
            },
            name: item["doctor_name"],
            position: item["doctor_specialities"],
          },
          createdAt: n.toDate(),
          description: item["trx_summary"] || item.detail_complaint,
          prescriptionId: item["prescription_id"],
          transactionDependency: item["transaction_dependency"],
          dependentStatus: Number(item["dependent_status"]),
          dependent: item["dependent"],
          patientName: item["patient_name"],
        });
      });

      const activeConsultation = mainPatient.active_consultation;

      setConsultation(activeConsultation);

      // set medical data from patient data
      setMedical(mainPatient.patient_height, mainPatient.patient_weight);

      const age = mainPatient.patient_age;
      // to handle if age is null, then set age = null. otherwise, age might be 0.
      const roundedAge =
        age === null || age === undefined ? null : Math.floor(Number(age));

      const symptompsCheckEnabled =
        mainPatient.config.is_symptoms_check_enabled;
      let doctorCheckEnabled = mainPatient.config.is_check_doctor_enabled;
      if (!symptompsCheckEnabled && !doctorCheckEnabled) {
        doctorCheckEnabled = true;
      }

      // ---------- new flow check active transaction ----------
      // prepare check active transaction in all member
      const checkActiveTransaction = patientList.map((patient) =>
        API.get(`${APP_BASE_URL}/v2/consultations/patient/${patient.id}`).then(
          (resp) => resp.data.data
        )
      );

      // GET check active transaction in patient and family member
      const activeTransaction = await axios.all(checkActiveTransaction).then(
        axios.spread((...transactions) => {
          return transactions.find((trx) => {
            if (trx.length !== 0) {
              console.log("you have one active transaction", trx);
              return trx[0];
            }
          });
        })
      );

      setConsultation(activeTransaction);

      this.setState({
        historiesData: histories,
        historiesTotal: consultationsHistoriesTotal,
        firstName: mainPatient.patient_f_name,
        fullName: mainPatient.patient_f_name + " " + mainPatient.patient_l_name,
        cardNumber: mainPatient.patient_card_number,
        organization: mainPatient.patient_organization,
        status: mainPatient.patient_vip_status ? "VIP" : "General",
        class: mainPatient.patient_class,
        age: roundedAge,
        gender: mainPatient.patient_gender,
        birthdate: moment(mainPatient.patient_dob).toDate(),
        hasDoB: !!mainPatient.patient_dob,
        phone: mainPatient.patient_phone,
        email: mainPatient.patient_email,
        id: mainPatient.id,
        dependenceStatus: Number(mainPatient.dependence_status),
        activeConsultation: getConsultation(),
        medical: getMedical(),
        isLoading: false,
        symptomsCheckUrl: mainPatient.config?.symptoms_check_url,
        config: mainPatient.config,
        hasViId: mainPatient.has_vi_id,
        newPatientId: mainPatient.id,
        clientId: profileData.client_id,
        inboxId:
          activeTransaction?.length > 0 ? activeTransaction[0].inbox_id : null,
        transactionId:
          activeTransaction?.length > 0
            ? activeTransaction[0].transaction_id
            : null,
        websiteToken:
          activeTransaction?.length > 0
            ? activeTransaction[0].website_token
            : null,
        activeTransaction,
        clientAppId: mainPatient.client_app_id,
      });

      if (this.props.screenProps.intent) {
        if (
          this.props.screenProps.intent.action === "text_message" &&
          mainPatient.active_consultation
        ) {
          this.props.navigation.navigate("Waiting", {
            patientId: this.state.id,
            activeConsultation: this.state.activeConsultation,
          });
        }
      } else if (mainPatient.transaction_to_post_assess) {
        this.props.navigation.navigate("PostAssessment", {
          transaction: {
            doctor: {
              avatarUrl:
                mainPatient.transaction_to_post_assess.doctor.doctor_photo,
              fullName: `${mainPatient.transaction_to_post_assess.doctor.octor_f_name} ${mainPatient.transaction_to_post_assess.doctor.octor_l_name}`,
            },
            startedAt:
              mainPatient.transaction_to_post_assess
                .consultation_chat_started_at,
            summary: mainPatient.transaction_to_post_assess.trx_summary,
          },
        });
      }

      // check for previous active consultation on local storage
      const prevConsultationData = await AsyncStorage.getItem(
        "active_consultation"
      );
      if (prevConsultationData) {
        const prevConsultation = JSON.parse(prevConsultationData);

        // check prev with current active consultation
        const isPrevConsultationActive = activeConsultation
          ? prevConsultation.trx_id === activeConsultation.trx_id &&
            prevConsultation.room_id === activeConsultation.room_id
          : false;
        if (!isPrevConsultationActive) {
          // transfer to rating page if previous consulation is not the same as current active
          this.props.navigation.navigate("Rating", {
            transactionId: prevConsultation.trx_id,
            agentAvatar: prevConsultation.avatar_url,
            agentName: prevConsultation.username,
            agentSpecialities: prevConsultation.email,
          });
        }
      }

      this.setState({ loading: false });
    } catch (error) {
      console.log(error?.response || error);
      this.props.screenProps.onClose();
    }
  }

  async componentDidMount() {
    this.checkLaunchStatus();
    try {
      const {
        data: { access_token, metadata },
      } = await API.post(
        `${APP_BASE_URL}/v2/profile/token`,
        {},
        {
          headers: {
            Authorization: `Bearer ${this.props.token}`,
          },
        }
      );
      this.props.saveAccessToken(access_token);
      this.props.saveClientId(metadata.client_id);
      this.promise = this.fetchProfile();
    } catch (error) {
      console.log(error?.response || error);
      this.props.screenProps.onClose();
    }
  }

  render() {
    if (this.state.isLoading) {
      return (
        <View
          style={{
            flex: 1,
            backgroundColor: this.props.themeColors.primary,
            justifyContent: "center",
          }}
        >
          <ActivityIndicator size="large" color="#fff" />
        </View>
      );
    }

    let consultationHistoriesRender;

    if (this.state.historiesTotal > 0) {
      consultationHistoriesRender = (
        <Timeline
          innerCircle="icon"
          circleColor={this.props.themeColors.lighterPrimary}
          lineColor={this.props.themeColors.primary}
          data={this.state.historiesData}
          detailContainerStyle={{ marginTop: -13, marginBottom: 13 }}
          listViewContainerStyle={{ marginLeft: 12, marginRight: 32 }}
          renderDetail={(rowData, sectionID, rowID) => {
            if (rowData.type === "section") {
              return <TimelineSection date={rowData.date} />;
            } else {
              return (
                <TimelineItem
                  createdAt={rowData.createdAt}
                  doctor={{
                    avatarUrl: rowData.doctor.avatar.uri,
                    specialities: rowData.doctor.position,
                    fullName: rowData.doctor.name,
                  }}
                  summary={rowData.description || ""}
                  transactionDependency={rowData.transactionDependency}
                  dependentStatus={rowData.dependentStatus}
                  dependent={rowData.dependent}
                  patientName={rowData.patientName}
                />
              );
            }
          }}
          showTime={false}
        />
      );
    } else {
      consultationHistoriesRender = null;
    }

    return (
      <ParallaxScrollView
        ref={(ref) => {
          this.scrollRef = ref;
        }}
        backgroundColor={this.props.themeColors.primary}
        parallaxHeaderHeight={600}
        refreshControl={
          <RefreshControl
            refreshing={this.state.loading}
            onRefresh={async () => await this.fetchProfile()}
          />
        }
        renderForeground={() => (
          <View>
            <Header
              onPress={() => {
                this.props.resetTokenStore();
                this.props.screenProps.onClose();
              }}
              position="start"
              text="Tutup"
              theme="light"
            />
            <View
              style={{
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <View>
                <AutoHeightImage
                  source={require("../assets/intro.png")}
                  width={Dimensions.get("window").width - 140}
                />
              </View>
              {this.state.config.is_check_doctor_enabled ? (
                <TouchableOpacity
                  onPress={this._onPress}
                  style={{ marginBottom: 16 }}
                >
                  <View
                    style={{
                      borderRadius: 30,
                      backgroundColor: staticColors.forestFern,
                    }}
                  >
                    <Text
                      style={{
                        fontSize: 20,
                        ...fonts.bold,
                        color: "#FFF",
                        width: 250,
                        textAlign: "center",
                        paddingVertical: 16,
                      }}
                    >
                      {this.state.activeConsultation
                        ? "LANJUT KONSULTASI"
                        : "TANYA DOKTER"}
                    </Text>
                  </View>
                </TouchableOpacity>
              ) : null}
              {this.state.config["is_prescription_claim_enabled"] ? (
                <TouchableOpacity
                  style={{ marginBottom: 16 }}
                  onPress={this.onHistoryPress}
                  style={{ marginBottom: 16 }}
                >
                  <View
                    style={{
                      borderRadius: 30,
                      backgroundColor: this.props.themeColors.darkestPrimary,
                    }}
                  >
                    <Text
                      style={{
                        fontSize: 20,
                        ...fonts.bold,
                        color: "#FFF",
                        width: 250,
                        textAlign: "center",
                        paddingVertical: 16,
                      }}
                    >
                      RIWAYAT RESEP
                    </Text>
                  </View>
                </TouchableOpacity>
              ) : null}

              {this.state.config.is_symptoms_check_enabled ? (
                <TouchableOpacity
                  onPress={this.onMedicalCheckPress}
                  style={{ marginBottom: 16 }}
                >
                  <View
                    style={{
                      borderRadius: 30,
                      backgroundColor: this.props.themeColors.lighterPrimary,
                    }}
                  >
                    <Text
                      style={{
                        fontSize: 20,
                        ...fonts.bold,
                        color: "#FFF",
                        width: 250,
                        textAlign: "center",
                        paddingVertical: 16,
                      }}
                    >
                      PERIKSA GEJALA
                    </Text>
                  </View>
                </TouchableOpacity>
              ) : null}
            </View>
          </View>
        )}
      >
        <View style={{ backgroundColor: this.props.themeColors.primary }}>
          <NavigationEvents
            onDidFocus={(payload) => {
              const consultation = getConsultation();
              const medical = getMedical();

              this.setState({
                activeConsultation: consultation
                  ? Object.assign({}, consultation)
                  : null,
                medical: medical ? Object.assign({}, medical) : null,
              });
            }}
          />
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              padding: 20,
            }}
          >
            <PatientAvatarWithDetail
              cardNumber={this.state.cardNumber}
              fullName={this.state.fullName}
              gender={this.state.gender}
            />
            <TouchableOpacity
              style={{ marginStart: 20 }}
              onPress={() => this.scrollRef.scrollTo({ x: 0, y: 500 })}
            >
              <Image
                source={require("../assets/baseline_keyboard_arrow_up_white_18dp.png")}
              />
            </TouchableOpacity>
          </View>
          <View
            style={{
              backgroundColor: "#FFF",
              borderTopEndRadius:
                Platform.OS === "android" && Platform.Version <= 26 ? 0 : 40,
              borderTopStartRadius:
                Platform.OS === "android" && Platform.Version <= 26 ? 0 : 40,
            }}
          >
            <View style={{ padding: 30, paddingTop: 15 }}>
              <View
                style={{
                  width: 64,
                  height: 6,
                  borderRadius: 3,
                  marginBottom: 15,
                  opacity: 0.5,
                  backgroundColor: "#808080",
                  alignSelf: "center",
                }}
              />

              <PatientDetailMore
                onEditPress={() => {
                  this.props.navigation.navigate("Medical", {
                    patientId: this.state.newPatientId,
                    age: this.state.age,
                    cardNumber: this.state.cardNumber,
                    fullName: this.state.fullName,
                    gender: this.state.gender,
                    height: this.state.medical
                      ? this.state.medical.height
                      : null,
                    weight: this.state.medical
                      ? this.state.medical.weight
                      : null,
                  });
                }}
                class={this.state.class}
                gender={this.state.gender}
                height={this.state.medical ? this.state.medical.height : null}
                organization={this.state.organization}
                weight={this.state.medical ? this.state.medical.weight : null}
                age={this.state.age}
              />
            </View>
            <View
              style={{
                backgroundColor: "#F1F1F1",
                height: 1,
                width: "100%",
                marginBottom: 30,
              }}
            />
            <Text
              style={{
                fontSize: 20,
                ...fonts.bold,
                color: this.props.themeColors.darkestPrimary,
                alignSelf: "center",
              }}
            >
              RIWAYAT KONSULTASI
            </Text>
            <Text
              style={{
                fontSize: 15,
                ...fonts.regular,
                color: this.props.themeColors.darkerPrimary,
                alignSelf: "center",
                marginBottom: 30,
              }}
            >
              {this.state.historiesTotal} Konsultasi
            </Text>
            {consultationHistoriesRender}
          </View>
        </View>
      </ParallaxScrollView>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    saveAccessToken: (accessToken) => dispatch(changeAccessToken(accessToken)),
    resetTokenStore: () => dispatch(resetTokenStore()),
    saveClientId: (clientId) => dispatch(saveClientId(clientId)),
  };
};

export default connect(
  (state) => ({
    introSlides: state.introSlides,
    themeColors: state.themeColors,
    token: state.token.token,
    clientId: state.appConfig.clientId,
  }),
  mapDispatchToProps
)(CustomerProfileScreen);
